import { TopicProvider } from 'src/contexts/topic.context';
import TopicLayout from './TopicLayout';

interface Props {
  children?: React.ReactNode;
}

export default function TopicLayoutWrapper({ children }: Props) {
  return (
    <TopicProvider>
      <TopicLayout>{children}</TopicLayout>
    </TopicProvider>
  );
}
